import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionSkinBestPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionSkinBest.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionSkinBest.button1'),
          value: 'oily',
        },
        {
          text: t('pages.onboarding.questionSkinBest.button2'),
          value: 'dry',
        },
        {
          text: t('pages.onboarding.questionSkinBest.button3'),
          value: 'combination',
        },
        {
          text: t('pages.onboarding.questionSkinBest.button4'),
          value: 'sensitive',
        },
        {
          text: t('pages.onboarding.questionSkinBest.button5'),
          value: 'acne_prone',
        },
        {
          text: t('pages.onboarding.questionSkinBest.button6'),
          value: 'dont_know',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
